import React from "react";
import DOMPurify from "dompurify";
import { Text, TypeStyle } from "@jsq/ds/deprecated";
import { type PrivacyPolicy } from "../types";

type Props = {
  arena: string;
  privacyType: string;
  termsAndConditionsDocuments: PrivacyPolicy;
};

export const PrivacyFields: React.FunctionComponent<Props> = (props) => {
  const { arena, privacyType, termsAndConditionsDocuments } = props;
  const getHtml = (el: any) => ({ __html: DOMPurify.sanitize(el) });

  if (arena === "jsq") {
    return (
      <Text typeStyle={TypeStyle.Paragraph}>
        {termsAndConditionsDocuments.jsq[privacyType]}
      </Text>
    );
  }
  return (
    <Text typeStyle={TypeStyle.Paragraph}>
      <div
        id="arena-terms-content"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={getHtml(termsAndConditionsDocuments[arena][privacyType])}
      />
    </Text>
  );
};

export default PrivacyFields;
